class DesktopMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.lastActiveTrigger = null
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.trigger?.exists) return

    this.closeAllSubmenus = this.closeAllSubmenus.bind(this)
    this.closeAllTriggers = this.closeAllTriggers.bind(this)
    this.showCloseButton = this.showCloseButton.bind(this)

    document.addEventListener('drawer-changed', () => {
      this.closeAllSubmenus()
      this.closeAllTriggers()
      this.showCloseButton()
      this.lastActiveTrigger = null
    })

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleBack = this.handleBack.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
    this.listeners.add(document, 'click', this.handleBack)
  }

  closeAllSubmenus () {
    this.externalEls.submenu.elements.forEach((submenuEl) => {
      submenuEl.setAttribute('aria-hidden', 'true')
    })
  }

  closeAllTriggers () {
    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute('aria-expanded', 'false')
    })
  }

  showCloseButton () {
    this.els.close.element.setAttribute('aria-hidden', 'false')
  }

  handleTrigger (event) {
    const clickedTrigger = event.target.closest(this.els?.trigger?.selector)
    if (!clickedTrigger) return

    const matchedSubMenu = this.externalEls.submenu.elements.find(
      (submenuEl) =>
        submenuEl.dataset.handle === clickedTrigger.dataset.handle &&
        submenuEl.dataset.level === clickedTrigger.dataset.level &&
        submenuEl.dataset.topNavHandle === clickedTrigger.dataset.topNavHandle,
    )

    if (!matchedSubMenu) return

    this.closeAllSubmenus()
    this.closeAllTriggers()

    matchedSubMenu.setAttribute('aria-hidden', 'false')

    clickedTrigger.setAttribute('aria-expanded', 'true')

    this.lastActiveTrigger = clickedTrigger

    setTimeout(() => {
      const backButtonEl = matchedSubMenu.querySelector(
        this.externalEls.back.selector,
      )
      backButtonEl?.focus()
    }, 500)

    this.els.close.element.setAttribute('aria-hidden', 'true')
  }

  handleBack (event) {
    const backButtonEl = event.target.closest(this.externalEls.back.selector)
    if (!backButtonEl) return

    const submenuEl = event.target.closest(this.externalEls.submenu.selector)
    if (!submenuEl) return

    submenuEl.setAttribute('aria-hidden', 'true')

    this.closeAllTriggers()
    this.showCloseButton()

    this.lastActiveTrigger?.focus()
    this.lastActiveTrigger = null
  }
}

if (!customElements.get('desktop-menu')) {
  customElements.define('desktop-menu', DesktopMenu)
}
